import type { MaybeComputedElementRef } from '@vueuse/core';
import type { ComputedRef } from 'vue';
import { breakpointsTailwind } from '@vueuse/core';
import { useContainerQuery } from './use-container-query';

/**
 * Reactive `true` while the target element is narrower than Tailwind's `sm` breakpoint. Wraps the
 * shared container-query helper so width-adaptive components agree on one "narrow view" threshold
 * instead of each re-deriving it. Container-scoped rather than viewport-scoped, so it stays correct
 * inside modals and panels that are narrower than the window.
 */
export function useIsNarrowView(target: MaybeComputedElementRef): ComputedRef<boolean> {
	return useContainerQuery(target, breakpointsTailwind).smaller('sm');
}
